import React from "react";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import AboutImage from "../../asset/homeAbout.png";
import "./AboutHome.css";

const COMPANY_START_YEAR = 1990;

const AboutHome = () => {
  const yearsOfExperience = new Date().getFullYear() - COMPANY_START_YEAR;

  return (
    <section className="about-company" aria-labelledby="about-company-title">
    <div className="about-company__top">
      <div className="about-company__heading">
        <p className="about-company__eyebrow">About our company</p>
        <h2 id="about-company-title">
          Precision engineering
          <br />
          for a world of performance.
        </h2>
      </div>

      <div className="about-company__stats" aria-label="Hardcoats highlights">
        <div><strong>{yearsOfExperience}+</strong><span>Years of experience</span></div>
        <div><strong>20+</strong><span>Industries served</span></div>
        <div><strong>2150+</strong><span>PROJECT EXECUTED</span></div>
      </div>
    </div>

    <div className="about-company__layout">
      <div className="about-company__image-card">
        <img src={AboutImage} alt="Hardcoats India manufacturing team" />
        <div className="about-company__image-shade" />
        <div className="about-company__image-copy">
          <strong>Since 1990</strong>
          <span>Engineering trust into every component.</span>
        </div>
      </div>

      <div className="about-company__services">
        <article className="about-company__card about-company__card--accent">
          <h3>Precision manufacturing</h3>
          <p>
            High-precision components and assemblies made to exacting standards
            for critical applications.
          </p>
          <Link to="/precision-component">Read more <ArrowRightIcon /></Link>
        </article>

        <article className="about-company__card about-company__card--sealing">
          <h3>Engineered sealing solutions</h3>
          <p>
            Reliable seals, bearings and assemblies designed for demanding
            pressure, temperature and movement conditions.
          </p>
          <Link to="/indigenously-developed-assemblies">Read more <ArrowRightIcon /></Link>
        </article>

        <article className="about-company__card about-company__card--wide">
          <h3>Built for industries that cannot compromise</h3>
          <p>
            From power and energy to defense, aerospace, packaging and oil &amp;
            gas, our teams combine advanced machinery, skilled workmanship and
            rigorous quality assurance to deliver dependable results.
          </p>
          <Link to="/aboutus">Discover Hardcoats <ArrowRightIcon /></Link>
        </article>
      </div>
    </div>
  </section>
  );
};

export default AboutHome;
